import React from 'react';
export const useDebounce = (initial, delay = 300) => {
    const [stateRaw, setRaw] = React.useState(initial);
    const [stateDebounced, setDebounced] = React.useState(initial);
    React.useEffect(() => {
        const timer = setTimeout(() => setDebounced(stateRaw), delay);
        return () => clearTimeout(timer);
    }, [stateRaw]);
    return {
        'value': stateRaw,
        'debounced': stateDebounced,
        'set': setRaw,
    };
};
export default useDebounce;
